<template>

	<div id="app">
		<debug-tool v-if="showDebug" />
		<div v-if="!isMobile">
			<transition name="fade" @leave="leavePreloader">
				<loader v-if="!showWebsite && !showDebug && !showEpisode && initialLoad" />
			</transition>
			<router-view></router-view>
		</div>
		<div v-else>
			<mobile v-if="isMobile"></mobile>
		</div>
	</div>

</template>

<script>

	import { mapState, mapActions, mapGetters } from 'vuex'
	import DebugTool from '@/components/tools/DebugTool'
	import Episode from './components/episodes/Episode'
	import Loader from './components/website/Loader'
	import Mobile from './components/website/Mobile'
	import moment from 'moment'

	export default {

		components: {
			'loader': Loader,
			'mobile': Mobile,
			DebugTool,
			Episode
		},

		data() {
			return {
				isMobile: false,
				activateScrollandAudio: false,
				activateScrollBottom: false,
				showDebug: false
				// showDebug: process.env.DEBUG_MODE
			}
		},

		beforeMount: function() {
			if (window.matchMedia("(max-device-width: 736px)").matches) {
				this.isMobile = true
			}
		},

		computed: {
			...mapState([
				'showEpisode',
				'showWebsite',
				'currentDate',
				'schedule',
				'initialLoad',
				'weekendEpisode'
			]),
			...mapGetters([
				'getTodaysEpisode'
			]),
			isInitialLoad () {
				return this.$
			}
		},

		created () {
			this.getSchedule()
			if(this.getTodaysEpisode.length <= 0) {
				this.getWeekendEpisodes()
			}
			const now = moment().format('YYYY-MM-DD')
			this.$store.commit('SET_DATE', now)
		},

		methods: {
			...mapActions([
				'getSchedule', 'getTodaysEpisode', 'getWeekendEpisodes'
			]),
			closeEpisode() {
				this.activateScrollBottom = true
			},
			leavePreloader() {
				this.activateScrollandAudio = true
			},
			changeScrollBottom() {
				this.activateScrollBottom = false
			}
		},
	}

</script>

<style lang="scss">
	@import "./assets/sass/main";

	a,
	button,
	.button {
	  -webkit-tap-highlight-color: rgba(0,0,0,0);
	}

	.video-wrapper {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: black;
		z-index: 999;
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity 2s 0s;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0
	}

	.fade-out-leave-active {
		transition: opacity 2s 0s;
	}

	.fade-out-leave-to {
		opacity: 0
	}

</style>



// WEBPACK FOOTER //
// App.vue?10938268